// ✅ src/lib/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAj7sYFuJpbObw03dSoJ3aqD4xkyzEkhwc",
  authDomain: "lirivellel.firebaseapp.com",
  projectId: "lirivellel",
  storageBucket: "lirivellel.firebasestorage.app",
  messagingSenderId: "700426441588",
  appId: "1:700426441588:web:c48e89aac7cb996455d221",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// ✅ IMPORTANT: functions export (callable uses this)
export const functions = getFunctions(app, "us-central1");
